import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'repeatString',
    standalone: false
})
export class RepeatStringPipe implements PipeTransform {

  transform(toRepeat: string, count: number): string {
    return toRepeat.repeat(count || 0);
  }

}
